import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import {
  patientStatusLabel,
  isPatientMarkedInactiveStatus,
} from '../../../lib/patientStatus';

const PatientTableRow = ({ patient, isSelected, onSelect, isAdmin }) => {
  const navigate = useNavigate();


  const handleViewProfile = () => {
    navigate(`/patient-profile/${patient?.dbId}`);
  };

  const handleCreateCase = () => {
    navigate('/case-detail', { state: { patientId: patient?.id, mode: 'create' } });
  };

  const getStatusColor = (status) => {
    if (isPatientMarkedInactiveStatus(status))
      return 'bg-muted text-muted-foreground';
    if (status === 'flagged') return 'bg-warning/10 text-warning';
    return 'bg-success/10 text-success';
  };

  return (
    <tr className="border-b border-border hover:bg-muted/50 transition-colors duration-200">
      <td className="px-6 py-4">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={(e) => onSelect(patient?.id, e?.target?.checked)}
          className="w-4 h-4 rounded border-border text-primary focus:ring-2 focus:ring-primary focus:ring-offset-2"
        />
      </td>
      <td className="px-6 py-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-primary/10 text-primary flex items-center justify-center font-medium">
            {patient?.initials}
          </div>
          <div>
            <p className="text-sm font-medium text-foreground">{patient?.name}</p>
            <p className="text-xs text-muted-foreground">ID: {patient?.id}</p>
          </div>
        </div>
      </td>
      <td className="px-6 py-4">
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2 text-sm text-foreground">
            <Icon name="Mail" size={14} className="text-muted-foreground" />
            <span>{patient?.email}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-foreground">
            <Icon name="Phone" size={14} className="text-muted-foreground" />
            <span>{patient?.phone}</span>
          </div>
        </div>
      </td>
      <td className="px-6 py-4">
        <span className="text-sm text-foreground">{patient?.registrationDate}</span>
      </td>
      <td className="px-6 py-4">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-foreground">{patient?.activeCases}</span>
          <span className="text-xs text-muted-foreground">Conception actifs</span>
        </div>
      </td>
      <td className="px-6 py-4">
        <span className="text-sm text-foreground">{patient?.lastVisit}</span>
      </td>
      <td className="px-6 py-4">
        <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${getStatusColor(patient?.status)}`}>
          {patientStatusLabel(patient?.status)}
        </span>
      </td>
      {isAdmin && (
        <td className="px-6 py-4">
          <span className="text-sm text-foreground">{patient?.dentist_client}</span>
        </td>
      )}
      <td className="px-6 py-4">
        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            size="icon"
            onClick={handleViewProfile}
            title="Voir le profil"
          >
            <Icon name="Eye" size={18} />
          </Button>
         
        </div>
      </td>
    </tr>
  );
};

export default PatientTableRow;